import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import $ from 'jquery'
import ReadAxios from '../axiosComponent/read';
const MyCity = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // console.log(props)
        setloading(true)
        // $("#searchType .dropdown").removeClass("dropdown")
        props.id ? 
        ReadAxios({ url: `cityMaster/${props.id}` })
            .then((result) => {
                if(result.data.resultSet){
                    setcontent(result.data.resultSet)
                }
                // console.log(result)
                setloading(false)
            })
            : setloading(false)
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ url: 'cityMaster', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    if(result.data.resultSet){
                        setcontent(result.data.resultSet)
                    }
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.cityCode
            temp.text = object.cityName
            temp.value = object.city_id
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyCity